import layout from '@/views/layout/layout.vue'
const autoTableList = r => require.ensure([], () => r(require('@/views/autoTable/table/list.vue')), 'all-autoTable-table')

const autoTable = [
  {
    path: '/autoTable/table',
    name: 'autoTable-table',
    component: layout,
    redirect: '/autoTable/table/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: autoTableList,
        name: 'autoTable-table-list',
        meta: {
          displayName: '动态表管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default autoTable



// WEBPACK FOOTER //
// ./src/router/autoTable/table.js